import React, { useRef, useState, useEffect } from 'react';
// @ts-ignore
import moment from 'moment';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import AppointmentModal from '../../../../Components/HealthPlan/Appointment/AppointmentModal';
import HealthPlanMedicalReportModal from '../HealthPlanMedicalReport/HealthPlanMedicalReportModal';
import HealthPlanOtherConsultationsModal from '../HealthPlanOtherConsultations/HealthPlanOtherConsultationsModal';
import HealthPlanLaboratoryExamModal from '../HealthPlanLaboratoryExam/HealthPlanLaboratoryExamModal';
import HealthPlanEducationMaterialsModal from '../HealthPlanEducationMaterials/HealthPlanEducationMaterialsModal';
import HealthPlanMonitoringModal from '../HealthPlanMonitoring/HealthPlanMonitoringModal';
import HealthPlanDiagnosticImagingModal from '../HealthPlanDiagnosticImaging/HealthPlanDiagnosticImagingModal';
import HealthPlanVaccinationModal from '../HealthPlanVaccination/HealthPlanVaccinationModal';
import HealthPlanElectronicPrescriptionModal from '../HealthPlanElectronicPrescription/HealthPlanElectronicPrescriptionModal';
import { HealthPlanTimelineItem } from '../../../../Models/HealthPlan/HealthPlanTimelineItem';

interface HealthPlanItemProps {
	item: HealthPlanTimelineItem;
	patientId: string;
	workplaceId: string;
	onClose: () => void;
}

export default function HealthPlanItem(props: HealthPlanItemProps) {
	const { item, patientId, workplaceId, onClose } = props;
	const { custom } = item.extra;

	useEffect(() => {
		if (item) {
			handleOpenModal(item.type);
		}
	}, []);

	const [modalOpened, setModalOpened] = useState({
		appointment: false,
		medicalEvaluation: false,
		otherConsultation: false,
		laboratoryExamination: false,
		educationMaterial: false,
		monitoring: false,
		diagnosticImaging: false,
		vaccination: false,
		electronicPrescription: false,
	});

	const handleOpenModal = (key: string) => {
		setModalOpened(prevValue => {
			return {
				...prevValue,
				[key]: true,
			};
		});
	};

	const handleCloseModal = (key: string) => {
		setModalOpened(prevValue => {
			return {
				...prevValue,
				[key]: false,
			};
		});
		onClose?.();
	};

	return (
		<>
			{item.type === 'appointment' && (
				<AppointmentModal
					opened={modalOpened.appointment}
					onClose={() => handleCloseModal(item.type)}
					patientId={patientId}
					healthPlanUserItemId={item.id}
					workplaceId={workplaceId}
					allowPickMeetingType={true}
					eventId={item.extra?.eventId}
				/>
			)}
			{item.type === 'medicalEvaluation' && (
				<HealthPlanMedicalReportModal
					patientId={patientId}
					workplaceId={workplaceId}
					opened={modalOpened.medicalEvaluation}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'otherConsultation' && (
				<HealthPlanOtherConsultationsModal
					opened={modalOpened.otherConsultation}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'laboratoryExamination' && (
				<HealthPlanLaboratoryExamModal
					opened={modalOpened.laboratoryExamination}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'educationMaterial' && (
				<HealthPlanEducationMaterialsModal
					opened={modalOpened.educationMaterial}
					onClose={() => handleCloseModal(item.type)}
					patientId={patientId}
				/>
			)}
			{item.type === 'monitoring' && (
				<HealthPlanMonitoringModal
					opened={modalOpened.monitoring}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'diagnosticImaging' && (
				<HealthPlanDiagnosticImagingModal
					opened={modalOpened.diagnosticImaging}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'vaccination' && (
				<HealthPlanVaccinationModal
					opened={modalOpened.vaccination}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'electronicPrescription' && (
				<HealthPlanElectronicPrescriptionModal
					opened={modalOpened.electronicPrescription}
					onClose={() => handleCloseModal(item.type)}
					patientId={patientId}
					defaultValues={item.extra?.data}
				/>
			)}
		</>
	);
}
